
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/subscription/courses",
      function () {
        return require("private-next-pages/subscription/courses/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/subscription/courses"])
      });
    }
  